<!-- src/views/Register.vue -->
<template>
  <section class="auth section container" style="padding-top:120px">
    <div class="auth-card glass">
      <h1 class="h1 auth-title">建立新帳號</h1>
      <p class="lead auth-sub">請填寫以下資訊完成註冊</p>

      <form class="auth-form" @submit.prevent="handleRegister">
        <!-- 顯示名稱（必填） -->
        <label class="label">顯示名稱</label>
        <input
          v-model.trim="name"
          type="text"
          class="input"
          placeholder="請輸入顯示名稱"
          required
        />

        <!-- Email -->
        <label class="label">電子郵箱</label>
        <input
          v-model.trim="email"
          type="email"
          class="input"
          placeholder="you@example.com"
          required
        />

        <!-- 密碼 -->
        <label class="label">密碼</label>
        <input
          v-model="password"
          type="password"
          class="input"
          placeholder="至少 8 個字元"
          required
        />

        <!-- 確認密碼 -->
        <label class="label">再次輸入密碼</label>
        <input
          v-model="confirmPassword"
          type="password"
          class="input"
          placeholder="請再次輸入密碼"
          required
        />

        <!-- 錯誤訊息 -->
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>

        <!-- 提交 -->
        <button
          class="btn btn--primary auth-btn"
          type="submit"
          :disabled="loading"
        >
          {{ loading ? '註冊中...' : '立即註冊' }}
        </button>
      </form>

      <p class="muted auth-foot">
        已有帳號？
        <router-link to="/login" class="auth-link">直接登入</router-link>
      </p>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { apiRegister, apiLogin } from '@/utils/auth'

const router = useRouter()

const name = ref('')
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const errorMsg = ref('')

const emailRegex = /^\S+@\S+\.\S+$/

async function handleRegister () {
  errorMsg.value = ''

  // ====== 前端校驗（含暱稱必填）======
  if (!name.value || !email.value || !password.value || !confirmPassword.value) {
    errorMsg.value = '請完整填寫所有欄位'
    return
  }

  const nickname = name.value.trim()
  if (!nickname) {
    errorMsg.value = '請輸入顯示名稱'
    return
  }

  if (!emailRegex.test(email.value)) {
    errorMsg.value = 'Email 格式不正確，請輸入有效信箱'
    return
  }

  if (password.value.length < 8) {
    errorMsg.value = '密碼至少需 8 個字元'
    return
  }

  if (password.value !== confirmPassword.value) {
    errorMsg.value = '兩次密碼不一致'
    return
  }

  loading.value = true

  try {
    // 註冊請求（暱稱必填直接送出，不再用 undefined）
    const res = await apiRegister({
      name: nickname,
      email: email.value.trim(),
      password: password.value
    })

    if (!res?.ok) {
      errorMsg.value = '註冊失敗，請稍後再試'
      return
    }

    // 註冊成功後自動登入
    await apiLogin({ email: email.value.trim(), password: password.value })
    router.push('/courses')
  } catch (err) {
    const e = err?.payload?.error
    if (e === 'EMAIL_TAKEN') errorMsg.value = '此信箱已被註冊'
    else if (e === 'INVALID_EMAIL') errorMsg.value = 'Email 格式不正確'
    else if (e === 'WEAK_PASSWORD') errorMsg.value = '密碼強度不足（至少 8 個字元）'
    else errorMsg.value = '註冊失敗，請稍後再試'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
/* 與 Login.vue 同風格排版 */
.auth { display: grid; place-items: center; }
.auth-card {
  width: min(520px, 92vw);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 18px;
  padding: 26px 22px 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}
.auth-title { margin: 0 0 8px; }
.auth-sub { margin: 0 0 18px; opacity: 0.9; }
.auth-form { display: grid; gap: 10px; }
.auth-btn { width: 100%; margin-top: 8px; }
.auth-foot { margin-top: 12px; }
.auth-link { text-decoration: underline; }
.error-msg { color: #f87171; font-size: 14px; margin: 4px 0 0; }
</style>
